import { render, staticRenderFns } from "./ProjectListing.vue?vue&type=template&id=431b972a&"
import script from "./ProjectListing.vue?vue&type=script&lang=js&"
export * from "./ProjectListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports